import { type FC } from "react";

import { type Conversation } from "@app_schema";

export const ConversationName: FC<{
  conversation: Pick<Conversation, "id"> & {
    agent: Pick<Conversation["agent"], "id" | "name">;
  };
}> = ({ conversation }) => (
  <>
    #{conversation.id} - {conversation.agent.name}
  </>
);
